import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthService } from './service/AuthGuard/auth.service';

const routes: Routes = [
	{
		path: 'mobile-passkey/:mode',
		loadChildren: () => import('./mobile-passkey/mobile-passkey.module').then(m => m.MobilePasskeyPageModule)
	},
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
    canActivate: [AuthService.authGuard]
  },
  {
    path: 'login/:next',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'job-detail',
    loadChildren: () => import('./job-detail/job-detail.module').then( m => m.JobDetailPageModule),
    canActivate: [AuthService.authGuard]
  },
  {
    path: 'new-customer',
    loadChildren: () => import('./new-customer/new-customer.module').then( m => m.NewCustomerPageModule),
    canActivate: [AuthService.authGuard]
  },
  {
    path: 'inspection',
    loadChildren: () => import('./inspection/inspection.module').then(m => m.InspectionPageModule),
    canActivate: [AuthService.authGuard]
  },
  {
    path: 'delivery-preparation',
    loadChildren: () => import('./delivery-preparation/delivery-preparation.module').then(m => m.DeliveryPreparationPageModule),
    canActivate: [AuthService.authGuard]
  },
  {
    path: 'camera-test',
    loadChildren: () => import('./camera-test/camera-test.module').then(m => m.CameraTestPageModule),
    canActivate: [AuthService.authGuard]
  }

];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { 
      preloadingStrategy: PreloadAllModules 
    }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
